import config from '../config';

export async function login({ username, password }) {
    const response = await fetch(`${config.API_URL}/users/login`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
    });
    if (response.status !== 200) {
        throw Error("Failed to login")
    }
    const data = await response.json();
    return data;
}
export async function register({ username, email, password }) {
    const response = await fetch(`${config.API_URL}/users/register`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password, email })
    });
    let body = await response.json();
    if (response.status === 200) {
        return { success: true }
    }
    throw Error(body.errorMessage);
}

export async function forgotPassword({ email }) {
    const response = await fetch(`${config.API_URL}/users/forgot-password`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email })
    });
    if (response.status !== 200) {
        throw Error("Something went wrong")
    }
    const res = await response.json();
    return res;
}
export async function resetPassword({ resetToken, password }) {
    const response = await fetch(`${config.API_URL}/users/reset-password`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ resetToken, password })
    });
    const res = await response.json();
    if (response.status !== 200) {
        throw Error(res.message)
    }
    return res;
}